export const ModalResetPasswordTranslationsUk = {
  resetPassword: 'Нагадати пароль',
  Email: 'Email',
  saveButton: 'Зберегти',
  enterYourEmail: 'Введіть свій Email',
};
